import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../components/common/Button';

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const ContentCard = styled.div`
  background: white;
  padding: 3rem 2.5rem;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 480px;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 2.5rem 2rem;
    border-radius: 20px;
    max-width: 100%;
  }
`;

const LogoContainer = styled.div`
  width: 200px;
  margin: 0 auto 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  @media (max-width: 768px) {
    width: 160px;
    margin-bottom: 2rem;
  }
`;

const Logo = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

const LogoPlaceholder = styled.div`
  font-size: 4rem;
  color: #adb5bd;
  
  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 0.75rem;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 2.5rem;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 0.9375rem;
    margin-bottom: 2rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  
  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  color: #adb5bd;
  font-size: 0.875rem;
  
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #dee2e6;
  }
  
  &::before {
    margin-right: 1rem;
  }
  
  &::after {
    margin-left: 1rem;
  }
`;

const Home: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <HomeContainer>
      <ContentCard>
        <LogoContainer>
          {/* logo.png 이미지가 있으면 표시, 없으면 플레이스홀더 */}
          <Logo 
            src="/logo.png" 
            alt="H_B Logo"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              e.currentTarget.nextElementSibling?.setAttribute('style', 'display: block');
            }}
          />
          <LogoPlaceholder style={{ display: 'none' }}>🏐</LogoPlaceholder>
        </LogoContainer>
        
        {/* <Title>H_B</Title> */}
        <Subtitle>
        H_B에 오신 것을 환영합니다
        </Subtitle>
        
        <ButtonGroup>
          <Button
            variant="primary"
            size="large"
            fullWidth
            onClick={() => navigate('/login')}
          >
            회원
          </Button>
          
          <Divider>or</Divider>
          
          <Button
            variant="outline"
            size="large"
            fullWidth
            onClick={() => navigate('/register')}
          >
            H_B 가입신청
          </Button>
          
          <Button
            variant="outline"
            size="large"
            fullWidth
            onClick={() => navigate('/guest-apply')}
          >
            H_B 게스트 신청
          </Button>
          {/* <a href="sms:01025820589?body=안녕하세요! H_B 배구동호회입니다.">테스트 문자 보내기</a> TODO */}

        </ButtonGroup>
      </ContentCard>
    </HomeContainer>
  );
};

export default Home;

